import { render, staticRenderFns } from "./musteri_sayisi.vue?vue&type=template&id=90236454"
import script from "./musteri_sayisi.vue?vue&type=script&lang=js"
export * from "./musteri_sayisi.vue?vue&type=script&lang=js"
import style0 from "./musteri_sayisi.vue?vue&type=style&index=0&id=90236454&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports